import React from "react";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Divider,
  ListItem,
  ListItemText,
  Switch,
  Typography,
} from "@mui/material";
import { ChevronDownIcon } from "@WahooFitness/redesignr";
import { t } from "@lingui/macro";
import AppleHealthIcon from "@/assets/AppleHealth.png";
import RecoveryDeviceList from "./RecoveryDeviceList";

// Android's view of an account whose recovery source is Apple Health (TAJ-1641). Android has no Apple
// Health, so the source is always set up on another device: the card shows it on, read-only, with the
// account's HRV device and a note that it can only be changed there. Same card shape as
// RecoverySourceApp, without anything that would change the source or the device.
const AppleHealthRecoveryElsewhere: React.FC = () => (
  <Accordion
    elevation={4}
    disableGutters
    defaultExpanded
    sx={{ "&:last-of-type": { borderRadius: 2 }, "&:first-of-type": { borderRadius: 2 } }}
    data-testid="apple-health-recovery-elsewhere"
  >
    <AccordionSummary expandIcon={<ChevronDownIcon />}>
      <Box display="flex" alignItems="center" gap={1}>
        <Box
          overflow="hidden"
          borderRadius={2}
          border={1}
          borderColor="divider"
          height={24}
          width={24}
          display="flex"
          alignItems="center"
          justifyContent="center"
        >
          <img width="24" height="24" alt="" src={AppleHealthIcon} />
        </Box>
        <Typography variant="prose-base">{t`Apple Health`}</Typography>
      </Box>
    </AccordionSummary>
    <AccordionDetails sx={{ px: 0, pb: 0 }}>
      <Divider />
      <ListItem dense>
        <ListItemText
          primary={t`HRV data source`}
          primaryTypographyProps={{ variant: "prose-base" }}
        />
        <Switch checked color="info" disabled />
      </ListItem>
      <RecoveryDeviceList />
    </AccordionDetails>
  </Accordion>
);

export default AppleHealthRecoveryElsewhere;
